import React from 'react';
import * as M from '@mui/material';
import _ from 'lodash';
import CloseIcon from '@mui/icons-material/Close';

export const Container = M.styled(M.Paper)(({ theme, ...props }) => ({
  height: '100%',
  width: '388px',
  maxWidth: '100%',
  padding: '0',
  boxSizing: 'border-box',
  boxShadow: '-1px 1px 5px 2px rgba(141, 141, 141, 0.24)',
  margin: '0 0 0 1px',
  borderLeft: 'solid 1px #dddddd',
  borderTop: 'solid 1px #dddddd',
  paddingTop: '24px',
  paddingBottom: '24px',
}));

export const Scroll = M.styled(M.Box)(({ theme }) => ({
  height: '100%',
  overflowY: 'scroll',
  borderRadius: '0px',
  paddingLeft: '16px',
  paddingRight: '16px',
  boxSizing: 'border-box',
}));

export const NoScroll = M.styled(M.Box)(({ theme }) => ({
  height: '100%',
  overflow: 'hidden',
  borderRadius: '0px',
  boxSizing: 'border-box',
}));

export const SimpleBox = M.styled(M.Box, {
  shouldForwardProp: (prop) => prop !== 'square',
})(({ theme, square }) => ({
  boxSizing: 'border-box',
  borderRadius: square ? 0 : 5,
}));

export const BorderBox = M.styled(SimpleBox, {
  shouldForwardProp: (prop) => !['borderColorPath', 'bgColorPath'].includes(prop),
})(({ theme, borderColorPath, bgColorPath }) => ({
  padding: '8px',
  border: `1px solid ${_.get(theme.palette, borderColorPath, theme.palette.primary.grayMain)}`,
  backgroundColor: _.get(theme.palette, bgColorPath, theme.palette.primary.transparent),
}));

export const ModalBox = M.styled(M.Box)(({ theme, ...props }) => ({
  maxWidth: '100%',
  boxSizing: 'border-box',
  padding: '24px',
  borderRadius: props.borderRadius || 0,
  position: 'relative',
  '&:focus': { outline: 'none' },
}));

export const ButtonIco = M.styled(M.IconButton)(({ theme, color }) => ({
  position: 'absolute',
  top: '0px',
  right: '0px',
  color: color || theme.palette.primary.grayMain,
  zIndex: 1,
}));

export const CloseButton = ({ color, theme, onClick, onKeyDown: userOnKeyDown, ...props }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.(e);
    }
  };

  const mergedKeyDown = (e) => {
    handleKeyDown(e);
    userOnKeyDown?.(e);
  };

  if (theme === 'main') {
    return (
      <ButtonIco color={color} onClick={onClick} onKeyDown={userOnKeyDown} {...props}>
        <CloseIcon fontSize={`large`} />
      </ButtonIco>
    );
  }

  return (
    <CloseLightIcon
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={mergedKeyDown}
      {...props}
    />
  );
};

const CloseLightIcon = M.styled(M.Box)(({ theme }) => ({
  width: '25px',
  height: '25px',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.white,
  border: `1px solid ${theme.palette.primary.black}`,
  position: 'absolute',
  top: '15px',
  right: '15px',
  zIndex: 1,
  cursor: 'pointer',
  '&::after': {
    content: '""',
    width: '1px',
    height: '15px',
    display: 'block',
    backgroundColor: theme.palette.primary.black,
    position: 'absolute',
    top: '0px',
    left: '0px',
    right: '0px',
    bottom: '0px',
    margin: 'auto',
    transform: `rotate(45deg)`,
  },
  '&::before': {
    content: '""',
    width: '1px',
    height: '15px',
    display: 'block',
    backgroundColor: theme.palette.primary.black,
    position: 'absolute',
    top: '0px',
    left: '0px',
    right: '0px',
    bottom: '0px',
    margin: 'auto',
    transform: `rotate(-45deg)`,
  },
}));
